export enum ProductsEnum {
  Free = 'Free',
  Silver = 'Silver',
  Gold = 'Gold',
  Platinum = 'Platinum',
  Custom = 'Custom',
}
